(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bsd-pdp-redesign"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (window.BSDPdpV2) return;
  window.BSDPdpV2 = {version: 'atelier-server-layout-2026-09-11'};
  
  function go(el) {
    if (!el) return;
    var pad = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 100;
    window.scrollTo({top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - pad - 16), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  }
  function reveal(root, kind) {
    if (kind === 'delivery') { go(root.querySelector('[data-apg-freight]')); return; }
    var rows = Array.from(root.querySelectorAll('#productAccordion .apg-bl-it'));
    if (!rows.length) rows = Array.from(root.querySelectorAll('.apg-bl-it'));
    var row = kind === 'specs' ? rows.find(function (r) { return /spec|dimension|download|technical/i.test((r.querySelector('.apg-bl-lab') || r).textContent); }) : rows[0];
    if (!row) row = rows[0];
    if (!row) return;
    var button = row.querySelector('.apg-bl-q');
    if (button && !row.classList.contains('open')) button.click();
    go(row);
  }
  function bootOne(root) {
    if (root.__bsdV2) return;
    root.__bsdV2 = true;
    root.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('[data-bsd-jump],[data-bsd-open-details]');
      if (!target) return;
      event.preventDefault();
      reveal(root, target.dataset.bsdJump || 'details');
    });
  }
  function boot() { document.querySelectorAll('.atelier-pdp').forEach(bootOne); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('product-info:loaded', function () { requestAnimationFrame(boot); });
})();



(function () {
  'use strict';
  if (window.BSDPdpLayoutFix) { window.BSDPdpLayoutFix.boot(); return; }
  var states = new Map();
  var queued = false;
  function install(root) {
    if (!root.classList.contains('bsd-pdp-v2')) return;
    var grid = root.querySelector('.apg-grid');
    if (!grid) return;
    var media = grid.querySelector(':scope > .apg-media');
    var boundary = grid.querySelector(':scope > .bsd-pdp-media-boundary');
    if (!boundary && media) {
      boundary = document.createElement('div');
      boundary.className = 'bsd-pdp-media-boundary';
      grid.insertBefore(boundary, media);
      if (typeof boundary.moveBefore === 'function') boundary.moveBefore(media, null);
      else boundary.appendChild(media);
    }
    if (!boundary) return;
    media = boundary.querySelector(':scope > .apg-media');
    if (!media) return;
    var current = states.get(root);
    if (!current || current.media !== media) {
      if (current && current.observer) current.observer.disconnect();
      var state = {media: media, boundary: boundary, observer: null};
      if (typeof ResizeObserver !== 'undefined') {
        state.observer = new ResizeObserver(schedule);
        state.observer.observe(media);
      }
      states.set(root, state);
    }
    var desktop = window.matchMedia('(min-width: 981px)').matches;
    var offset = parseFloat(getComputedStyle(media).getPropertyValue('--apg-sticky-top')) || 128;
    var available = document.documentElement.clientHeight - offset - 16;
    var tooTall = desktop && media.getBoundingClientRect().height > available;
    if (boundary.classList.contains('bsd-pdp-media-tall') !== tooTall) {
      boundary.classList.toggle('bsd-pdp-media-tall', tooTall);
    }

  }
  function boot() {
    queued = false;
    states.forEach(function (state, root) {
      if (!root.isConnected) {
        if (state.observer) state.observer.disconnect();
        states.delete(root);
      }
    });
    document.querySelectorAll('product-info.atelier-pdp').forEach(install);
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(boot); }
  }
  window.BSDPdpLayoutFix = {version: '2.1', boot: boot};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  window.addEventListener('load', schedule, {once: true});
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('product-info:loaded', schedule);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bsd-price-beat-banner"] && !Shopify.designMode) return;
  try {
    (() => {
  function prepare(event) {
    const link = event.target.closest('[data-bsd-price-beat]');
    if (!link) return;
    const root = link.closest('product-info');
    if (!root) return;
    const handle = location.pathname.split('/products/')[1]?.split('/')[0];
    const variant = root.querySelector('product-form form input[name="id"]')?.value;
    const quantity = root.querySelector('input[name="quantity"]')?.value || '1';
    const url = new URL(link.href);
    if (handle) url.searchParams.set('product', handle);
    if (variant) url.searchParams.set('variant', variant);
    url.searchParams.set('quantity', String(Math.max(1, parseInt(quantity, 10) || 1)));
    link.href = url.href;
  }
  document.addEventListener('pointerdown', prepare);
  document.addEventListener('click', prepare);
  document.addEventListener('focusin', prepare);
})();
  } catch(e) { console.error(e); }
})();

})();
